<template>
    <header class="header fixed-top">
        <nav>
            <router-link to="/" class="logo">
                <img :src="company_avatar" style="max-width: 200px;" :alt="$t('misc.company_logo')">
            </router-link>
            <!-- Sidebar toggle button-->
            <div class="float-left" v-if="requiresPerms">
                <a href="javascript:void(0)" class="sidebar-toggle" @click="toggle_menu">
                    <i class="fa fa-bars"></i>
                </a>
            </div>
            <div class="navbar-right">
                <div>
                    <div class="dropdown hidden-xs-down btn-group fullscreen" v-if="fullscreen">
                        <a href="javascript:void(0)" @click="fullscreen" :title="$t('misc.toggle_fullscreen')">
                            <i class="fa fa-arrows-alt"></i>
                        </a>
                    </div>

                    <!--
                    <b-dropdown class="notifications-menu bell_bg" right link>
                        <span slot="text">
                            <img :src="require(`@/assets/img/lang/${this.$store.state.language}.png`)">
                        </span>
                        <b-dropdown-item class="dropdownheader flags-menu" exact v-for="(lang, idx) in languages" :key="idx" @click="changeLanguage(lang.code)">
                            <img :src="require(`@/assets/img/lang/${lang.img}`)" :alt="lang.name">
                            <span>{{ lang.name }}</span>
                        </b-dropdown-item>
                    </b-dropdown>
                    -->

                    <b-dropdown class="user user-menu bell_bg user_btn" right link v-if="requiresPerms">
                        <span slot="text">
                            <img :src="user_avatar" class="rounded-circle" :alt="$t('misc.avatar')">
                            <p class="user_name_max">{{this.$store.state.user.user.name}}</p>
                        </span>
                        <b-dropdown-item exact class="dropdown_content">
                            <router-link to="/profile" exact class="drpodowtext">
                                <i class="fa fa-user-o"></i> {{$t('sidebar.profile')}}
                            </router-link>
                        </b-dropdown-item>
                        <b-dropdown-item exact class="dropdown_content">
                            <div @click="logoutUser" exact class="drpodowtext" style="padding-left: 15px; height: 30px">
                                <i class="fa fa-sign-out"></i> {{$t('sidebar.logout')}}
                            </div>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
    import screenfull from "screenfull"
    import http from '@/libs/http';
    export default {
        name: 'fixed-header',
        data() {
            return {
            }
        },
        computed: {
            user_avatar: {
                get: function () {
                    let user_avatar = this.$store.getters.getUserAvatar;
                    return user_avatar;
                }
            },
            company_avatar: {
                get: function () {
                    let company_avatar = this.$store.getters.getUserCompanyAvatar;
                    return company_avatar;
                }
            },
            requiresPerms: {
                get: function() {
                    if (typeof this.$route.meta.requiresPermissions != 'undefined') {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            languages: {
                get: function () {
                    let languages = this.$store.getters.getLanguages;
                    return languages;
                }
            },
        },
        watch: {
            user_avatar: {
                immediate: true,
                deep: true,

                handler(newVal, oldVal) {
                }
            },
            company_avatar: {
                immediate: true,
                deep: true,

                handler(newVal, oldVal) {
                }
            },
            requiresPerms: {
                immediate: true,
                deep: true,

                handler(newVal, oldVal) {
                }
            },
            languages: {
                immediate: true,
                deep: true,
                handler(newVal, oldVal) {
                }
            },
        },
        methods: {
            toggle_menu() {
                this.$store.commit('left_menu', "toggle");
            },
            fullscreen() {
                if (screenfull.enabled) {
                    screenfull.toggle();
                }
            },
            logoutUser() {
                this.$store.dispatch('logoutUser');
            },
            changeLanguage(idx) {
                this.$store.commit('SET_LANGUAGE', idx);
            }
        },
        mounted: function() {
            this.$store.dispatch('getLanguages');
        },
    }
</script>
<style lang="scss" scoped>
    @import "../css/customvariables";
    .header {
        z-index: 1030;
        nav {
            margin-bottom: 0;
            height: 50px;
            background: $header_color;
            background-size: 100% 100%;
            box-shadow: 0px 0px 10px #ccc;
        }
        .navbar-right {
            float: right;
            margin-right: 15px;
        }
        .logo {
            display: block;
            float: left;
            height: 50px;
            line-height: 41px;
            padding: 3px 10px;
            text-align: center;
            width: 250px;
            background: $header_color;
            img {
                max-height: 45px;
            }
        }
        .navbar-right {
            .dropdown-item {
                padding: 5px 0 5px 5px;
                outline: none;
                img {
                    width: 45px;
                    height: 30px;
                }
            }
            div.dropdown {
                >a {
                    color: $zoom_color;
                }
                .dropdown-menu>button {
                    padding: 10px 15px;
                }
                &.notifications-menu {
                    height: 50px;
                    .noti-icon {
                        font-size: 18px;
                    }
                    > button > span > img {
                        height: 38%;
                        width: 38%;
                    }
                }
                >a>i {
                    font-size: 23px;
                }
                >a {
                    display: block;
                    padding: 12px;
                }
                &:hover>a {
                    background-color: #ededed;
                    color: #000;
                }
                >a.padding-user {
                    padding-top: 8px;
                    padding-bottom: 6px;
                }
            }
        }
        nav .sidebar-toggle {
            float: left;
            color: $toggle_color;
            font-size: 19px;
            padding-top: 10px;
        }
    }

    .user_name_max {
        display: inline-block;
        max-width: 180px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        margin: 0 0 -4px;
    }

    .noti_msg {
        font-size: 16px;
        padding: 10px;
        border: 1px solid #4f90c1;
        border-radius: 50px;
        margin-top: 10px;
    }

    .user.user-menu>button img {
        width: 35px;
        height: 35px;
    }
    @media screen and (max-width: 767px) {
        .dropdown.open .dropdown-menu {
            position: absolute;
        }
        .navbar-right>li>a {
            padding: 10px 12px;
        }
    }

    @media (max-width: 560px) {
        body .header .logo,
        body .header nav {
            width: 100%;
        }
        body .header nav .sidebar-toggle {
            padding-left: 15px;
        }
        nav {
            height: 100px !important;
        }
    }

    .notifications_badge_top {
        margin-top: -28px;
        margin-left: 10px;
        position: absolute;
        span {
            top: 1px;
            left: 2px;
            border-radius: 50%;
            font-size: 9px;
            padding: 0.23em 0.45em;
        }
    }

    .dropdown-footer {
        padding: 10px !important;
    }

</style>
<style type="text/css" lang="scss">
    @import "../css/customvariables";
    .wrapper {
        margin-top: 50px;
        @media screen and (max-width: 560px) {
            margin-top: 100px;
        }
    }

    .sidebar-toggle {
        margin-left: 10px;
    }

    .bell_bg {
        button.btn-secondary {
            background-color: $bell-color;
            border: none;
            border-radius: 0;
            box-shadow: none !important;
            padding:0;
            &:hover {
                background-color: #ededed !important
            }
            &:active {
                color: $toggle_color !important;
            }
        }
        &.show button {
            background-color: $bell-active !important
        }
        &.user_btn .dropdown-toggle {
            padding:7px 9px;
        }
    }

    .tabs_cont,
    .event_date {
        background-color: #fff !important;
    }
    body.left-hidden aside.right-aside {
        margin-left: 0;
    }
    body.left-hidden .header.fixed-top{
        padding-right: 0 !important;
        min-width: 250px;
    }

</style>



// WEBPACK FOOTER //
// src/components/layouts/header/fixed-header.vue